import React, { useState, useEffect } from 'react';
import { EventCard } from './EventCard';

export default function TalksAndEvents() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const fetchEvents = async () => {
      try {
        const response = await fetch('https://sanjaydhir.com/api/events');
        if (!response.ok) {
          throw new Error('Failed to fetch events from server');
        }
        const data = await response.json();
        
        if (isMounted) {
          const sortedData = data.sort((a, b) => new Date(b.date) - new Date(a.date));
          setEvents(sortedData);
        }
      } catch (err) {
        if (isMounted) {
          setError(err.message);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    fetchEvents();

    return () => {
      isMounted = false; // Cleanup to prevent state updates on unmounted component
    };
  }, []); // Strictly empty array: Fetch runs ONCE on mount

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center py-5 text-light" style={{ minHeight: '60vh' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading events...</span>
        </div>
        <span className="ms-3 text-secondary">Loading events...</span>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container py-5 text-center text-danger">
        <p>Error loading events: {error}</p>
      </div>
    );
  }

  return (
    <div className="container py-5 text-light" style={{ maxWidth: '900px' }}>
      <div className="text-center mb-5">
        <h1 className="fw-bold text-white mb-2">Recent Events</h1>
        <p className="text-secondary small">Stay updated with our latest activities and happenings</p>
      </div>

      {events.length === 0 ? (
        <div className="text-center text-secondary py-5">
          No events found.
        </div>
      ) : (
        <div className="d-flex flex-column gap-4">
          {events.map((event) => (
            <EventCard key={event._id} event={event} />
          ))}
        </div>
      )}
    </div>
  );
}